import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import Validator from 'validatorjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';
import CartaPorteClienteManager from '../../../../catalogs/managers/CartaPorteClienteManager';

class CartaPorteAutotransporteRemolquesForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidMount() {
    const SubtipoRemolque = CartaPorteCatalogoManager.get('c_cp_subtipo_remolque');

    const { remolques } = CartaPorteClienteManager.get('carta-porte');

    let catalogos = {};

    catalogos.SubtipoRemolque = this.getCatalogo(SubtipoRemolque);
    catalogos.ClienteRemolques = this.getSortedCatalogoCliente(remolques, 'placa', 'placa');

    this.setState({
        catalogos
      });
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
        remolques: !!data.Remolques,
      });
    }
  }

  rules(data) {
    return {
      'SubTipoRem': ['required', 'string'],
      'Placa': ['required', 'string', 'regex:/^[^(?!.*s)-]{5,7}$/'],
    }
  }

  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(values.map((item) => {
        return {
          label: item.remolque_o_semirremolque,
          value: item.clave
        }
      }), 'label');

      return [
        {
          label: 'Selecciona',
          value: ''
        }
      ].concat(sorted);
    }
  }

  getSortedCatalogoCliente = (values, label, id) => {
    if (!values) {
      return [];
    }

    return _.sortBy(values.map((item) => {
      return {
        label: `Placa: ${item[label]}`,
        value: item[id],
        clave_tipo_remolque: item.clave_tipo_remolque,
        subtipo_de_remolque: item.subtipo_de_remolque,
        placa: item.placa,
      }
    }), 'placa');
  }

  handleOnRemolquesChange = (value) => {
    let data = {
      ...this.state.data,
      ...value,
    }

    if (!_.isEmpty(value)) {
      data = {
        ...this.state.data,
        ClienteRemolques: value.placa.toString(),
        SubTipoRem: value.subtipo_de_remolque.toString(),
        Placa: value.placa.toString(),
      };
    }

    this.notifyFormDataChange(data);
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      data: {}
    })
  }

  handleOnRefreshData = () => {
    this.setState({
      isValid: false,
      data: {}
    })
  }

  render() {
    const rules = this.rules();
    const {
      isValid,
      data = {},
      catalogos = {}
    } = this.state;

    return (
      <>
        <Row className="pb-2">
          <Col sm md={ 11 }>
            <FormControl type="ahead"
              label="Catálogo Remolques"
              id="ClienteRemolques"
              name="ClienteRemolques"
              help=""
              value={ data.ClienteRemolques }
              placeholder={ data.ClienteRemolques }
              options={ catalogos.ClienteRemolques }
              onSelect={ this.handleOnRemolquesChange }
            />
          </Col>

          <Col sm md={ 1 } className="text-right" style={ { marginTop: "28px" } }>
            <Button
              size="lg"
              variant="secondary"
              onClick={ this.handleOnRefreshData }
            >
              <FontAwesomeIcon icon={ ['fas', 'trash'] } />
            </Button>
          </Col>
        </Row>

        <Row>
          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Subtipo de Remolque"
              name="SubTipoRem"
              placeholder=""
              help=""
              rules={ rules.SubTipoRem }
              value={ data.SubTipoRem }
              options={ catalogos.SubtipoRemolque }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Placa"
              name="Placa"
              placeholder=""
              help=""
              minLength="1"
              maxLength="10"
              rules={ rules.Placa }
              value={ data.Placa }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>
        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar remolque
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteAutotransporteRemolquesForm;